module.exports = __webpack_public_path__ + "img/box-shadow.20dab318.svg";